export default {
      id: "ic-arrow-up-white-usage",
      viewBox: "0 0 18 11",
      url: "/" + "images/icons.3.109.2.svg#ic-arrow-up-white-usage",
      toString: function () {
        return this.url;
      }
    }